import { Children } from 'react'
import { cn } from '@/common/lib/cn/cn'
import Logo from './logo.svg'
import { DrawerLabel } from '../Drawer'
import { Icon } from '../Icon'
import './navbar.css'
import { Link } from 'react-router-dom'

export type NavbarProps = {
    drawerId: string
    className?: string
    children: React.ReactNode
    logoGradient?: boolean
    logoLinkAsAnchor?: boolean
    showMenuToggleOnLarge?: boolean
}

export const Navbar = ({
    drawerId,
    className = '',
    children,
    logoGradient = false,
    logoLinkAsAnchor = false,
    showMenuToggleOnLarge = false,
}: NavbarProps) => {
    const [menu, rightMenu] = Children.toArray(children)
    const NavbarClass = cn('navbar bg-base-100 shadow-sm', className)
    const logo = <Logo className={cn('h-[18.185px] w-[100px] mt-[2px]', logoGradient && 'navbar-admin-logo-mark')} />

    return (
        <div className={NavbarClass}>
            <DrawerLabel className={cn(!showMenuToggleOnLarge && 'lg:hidden')} id={drawerId} aria-label='Открыть меню'>
                <div className='cursor-pointer leading-1 mr-2'>
                    <Icon name='menu' size='lg' aria-hidden />
                </div>
            </DrawerLabel>
            <div className='flex items-center'>
                {logoLinkAsAnchor ? (
                    <a href='/app/' className='inline-flex' aria-label='На главную приложения'>
                        {logo}
                    </a>
                ) : (
                    <Link to='/app/' className='inline-flex' aria-label='На главную приложения'>
                        {logo}
                    </Link>
                )}
            </div>

            <div className='flex-1'>{menu}</div>
            <div className='flex-none'>{rightMenu}</div>
            {/* <div className='flex-none'>
                <button className='btn btn-square btn-ghost'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        className='inline-block h-5 w-5 stroke-current'
                    >
                        {' '}
                        <path
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            stroke-width='2'
                            d='M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z'
                        ></path>{' '}
                    </svg>
                </button>
            </div> */}
        </div>
    )
}
